"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = __importDefault(require("zod"));
exports.requestSchema = zod_1.default.object({
    groupId: zod_1.default.number(),
});
exports.path = '/irrigation-zone-emitter-group-delete';
//# sourceMappingURL=index.js.map